export const WEEK_KO = ['일', '월', '화', '수', '목', '금', '토'] as const;
export const MON_START_WEEK_KO = ['월', '화', '수', '목', '금', '토', '일'] as const;
